const MuiPopover = {
  defaultProps: {},
  styleOverrides: {}
};
export {
  MuiPopover
};
//# sourceMappingURL=MuiPopover.js.map
